import { useSelector } from 'react-redux';

import { getIsJourneysSubscriptionPrefMultiSelectEnabled } from 'modules/workflows/ducks';
import { FormField } from 'ui/formField';
import { colors } from 'ui/theme';
import { HelpToggletip } from 'ui/tooltip';
import { StyledFormLabel } from '../ModifySubscriptionEditor.styles';
import MultiSubscriptionPicker from './MultiSubscriptionPicker';
import SingleSubscriptionPicker from './SingleSubscriptionPicker';
import { SubscriptionPickerProps } from './SubscriptionPicker.types';
import { UseMultiSubscriptionDataProvider } from './useMultiSubscriptionData';

const SubscriptionPicker = ({
  hasError = false,
  errorText = '',
  isDisabled = false,
  nodeData,
  placeholder,
  onSelect,
}: SubscriptionPickerProps) => {
  const isJourneysSubscriptionPrefMultiSelectEnabled = useSelector(
    getIsJourneysSubscriptionPrefMultiSelectEnabled,
  );

  return (
    <FormField hasError={hasError} errorText={errorText}>
      <StyledFormLabel>
        {isJourneysSubscriptionPrefMultiSelectEnabled
          ? 'Messaging preferences'
          : 'Message channel or type'}
        <HelpToggletip
          iconProps={{ color: colors.secondaryText }}
          tooltipContent="Channels are broad categories for the messages you send. Message types allow for more specific, focused grouping inside each channel."
        />
      </StyledFormLabel>
      {isJourneysSubscriptionPrefMultiSelectEnabled ? (
        <UseMultiSubscriptionDataProvider>
          <MultiSubscriptionPicker
            nodeData={nodeData}
            isDisabled={isDisabled}
            hasError={hasError}
            onSelect={onSelect}
          />
        </UseMultiSubscriptionDataProvider>
      ) : (
        <SingleSubscriptionPicker
          nodeData={nodeData}
          isDisabled={isDisabled}
          placeholder={placeholder}
          hasError={hasError}
          onSelect={onSelect}
        />
      )}
    </FormField>
  );
};

export default SubscriptionPicker;
